import React from "react";
import { motion } from "framer-motion";
import { MapPinIcon } from "./icons/FeatherIcons";

interface LocationPermissionPromptProps {
  onAction: () => void;
  isRequesting: boolean;
}

const LocationPermissionPrompt: React.FC<LocationPermissionPromptProps> = ({
  onAction,
  isRequesting,
}) => {
  const title = "Location Access Denied";
  const message =
    "To see activities on the map, please enable location access in your browser or system settings. Then, click retry.";

  let buttonText = "Retry";
  if (isRequesting) {
    buttonText = "Requesting...";
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="absolute inset-0 bg-gray-800/80 backdrop-blur-sm flex flex-col items-center justify-center text-white text-center p-6 z-50"
    >
      <div className="w-24 h-24 rounded-full bg-primary/20 flex items-center justify-center mb-6">
        <MapPinIcon className="w-12 h-12 text-primary" />
      </div>
      <h2 className="text-2xl font-bold">{title}</h2>
      <p className="mt-2 text-gray-300 max-w-sm mb-8">{message}</p>

      <button
        onClick={onAction}
        disabled={isRequesting}
        className="bg-primary text-white font-bold py-3 px-8 rounded-full shadow-lg shadow-primary/30 transform hover:scale-105 transition-transform disabled:opacity-70 disabled:scale-100"
      >
        {buttonText}
      </button>
    </motion.div>
  );
};

export default LocationPermissionPrompt;
